import React from 'react';
import { AppLayout } from '@/components/layout/app-layout';
import { PageHeader } from '@/components/layout/page-header';
import { DailyProductivity } from '@/components/operational/DailyProductivity';
import { ProcessingWorkflow } from '@/components/operational/ProcessingWorkflow';
import { MandateAIOverview } from '@/components/operational/MandateAIOverview';
import { MandateAIInsights } from '@/components/operational/MandateAIInsights';

const Operational = () => {
  return (
    <AppLayout>
      <PageHeader 
        title="Operational Dashboard"
        subtitle="Daily productivity and processing insights"
        showMandateBadge
        quickActionLabel="Quick Action"
        onQuickAction={() => {/* TODO: Implement quick action */}}
      />
      <main className="flex-1 p-page-padding lg:p-page-padding-lg overflow-y-auto">
        <DailyProductivity />
        <ProcessingWorkflow />
        
        {/* AI Intelligence Section */}
        <section className="mt-8">
          <h2 className="text-xl font-bold text-brand-primary mb-6">AI Intelligence Hub</h2>
          <div className="grid grid-cols-1 xl:grid-cols-2 gap-6">
            <MandateAIOverview />
            <MandateAIInsights />
          </div>
        </section>
        
        <footer className="mt-8 pt-6 border-t border-brand-border flex justify-between items-center">
          <p className="text-xs text-brand-text-primary">Copyright © 2024 Swiss Finance OS</p>
          <div className="flex items-center gap-4 text-xs text-brand-text-secondary">
            <span className="hover:text-brand-primary cursor-pointer">Help Center</span>
            <span className="hover:text-brand-primary cursor-pointer">Submit Feedback</span>
          </div>
        </footer>
      </main>
    </AppLayout>
  );
};

export default Operational;